import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DataServiceService } from "../data-service.service";
import { DateHelperServiceService } from "../helpers/date-helper-service.service";
import { Company } from "../model/Company";

@Component({
  selector: "app-view-company",
  templateUrl: "./view-company.component.html",
  styleUrls: ["./view-company.component.scss"],
})
export class ViewCompanyComponent implements OnInit {
  companyId: string = "";
  companyData: Company;
  isLoading: boolean = true;
  constructor(
    private router: Router,
    private dataService: DataServiceService,
    private route: ActivatedRoute,
    public dateHelper: DateHelperServiceService
  ) {
    this.companyId = this.route.snapshot.params.companyId
      ? this.route.snapshot.params.companyId
      : "";
  }

  ngOnInit(): void {
    this.getCompanyData(this.companyId).then(() => {
      this.isLoading = false;
    });
  }

  editCompany() {
    this.router.navigate(["/edit-company", this.companyId]);
  }

  async getCompanyData(companyId) {
    this.companyData = await this.dataService.getCompanyById(companyId);
  }
}
